<script setup>
import { ref, defineAsyncComponent } from 'vue';

// Composant
const Icon = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Icon'));
const DeclineModal = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Users/RequestedHolidays/DeclineModal'));

// Props
const props = defineProps({
    request: {
        type: Object,
        required: true
    }
});

const modalOpened = ref(false);
const success = ref(false);

const onSuccess = (() => {
    success.value = true;
    modalOpened.value = false;

    setTimeout(() => {
        success.value = false;
    }, 3000);
});
</script>

<template>

    <button
        class="button button-image button-icon button-loader"
        :title="$t('page.admin.requestedHolidays.decline.button.label')"
        @click="modalOpened = true"
    >
        <icon name="times-circle"></icon>
    </button>

    <decline-modal
        v-if="modalOpened"
        :request="request"
        v-on:close-modal="modalOpened = false"
        v-on:success="onSuccess()"
    ></decline-modal>
</template>
